import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { theme } from '_constants/theme';

import Paginate from 'components/shared/Paginate';
import Text from 'components/shared/layouts/Text';

import SubscriptionCard from './SubscriptionCard';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spaces.regular}px;
`;
const SubscriptionsList = ({ loading, items, pageCount, currentPage, onPageChange, onUnsubscribe }) => {
  return (
    <StyledContainer>
      {items?.map((item) => (
        <SubscriptionCard key={item?.orderId} {...item} onUnsubscribe={onUnsubscribe} />
      ))}
      {!loading && !items?.length && <Text centered>No subscriptions found</Text>}
      <Paginate pageRangeDisplayed={3} pageCount={pageCount} currentPage={currentPage} onPageChange={onPageChange} />
    </StyledContainer>
  );
};

SubscriptionsList.propTypes = {
  loading: PropTypes.bool,
  items: PropTypes.array,
  pageCount: PropTypes.number,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func,
  onUnsubscribe: PropTypes.func,
};

export default SubscriptionsList;
